// extracted by mini-css-extract-plugin
export default {"proListItem":"AssignedProListItem_proListItem__OibNy","proListItemImage":"AssignedProListItem_proListItemImage__GnIuy"};